var rootCategoryId = '00000000-0000-0000-0000-000000000000';
var slugify = function (text) {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
};
var CategoryBuilder = /** @class */ (function () {
    function CategoryBuilder() {
        var defaultCategory = {
            id: '01d1d0e8-5245-49d4-8f1b-92bf07e05f86',
            locale: 'en',
            name: 'Category Title',
            parentId: rootCategoryId,
            url: 'http://fullurl.com',
            uri: '/cat-uri',
        };
        this.category = defaultCategory;
    }
    CategoryBuilder.prototype.withName = function (name) {
        this.category.name = name;
        this.category.uri = '/' + slugify(name) + (Math.random() * 999).toFixed(0);
        return this;
    };
    CategoryBuilder.prototype.withChildren = function (children) {
        var _this = this;
        children.forEach(function (cat) {
            cat.parentId = _this.category.id;
        });
        this.category.children = children;
        return this;
    };
    CategoryBuilder.prototype.withId = function (id) {
        this.category.id = id;
        return this;
    };
    CategoryBuilder.prototype.withLang = function (locale) {
        this.category.locale = locale;
        return this;
    };
    CategoryBuilder.prototype.build = function () {
        return this.category;
    };
    return CategoryBuilder;
}());
export { CategoryBuilder };
//# sourceMappingURL=category.js.map